import { GameFrame } from '@/features/game-client/game-frame';
import { gameContextSelector } from '@/features/game-context/store/game-context';
import { buildDgcUrl } from '@/features/providers/dgc/dgc-url-builder';
import { FgpDgcLaunchData } from '@/features/providers/dgc/types';
import { GameDataProp } from '@/features/providers/types';
import { useAppSelector } from '@/store/hooks';

export const Dgc: React.FC<GameDataProp> = ({ data }: GameDataProp) => {
  const { gameName } = useAppSelector(gameContextSelector);
  const url = buildDgcUrl(data as FgpDgcLaunchData);

  return <GameFrame title={gameName} url={url} />;
};
